import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopVoucherFragment = { __typename: 'ShopVoucherObject', id: number, code: string, currency: string, value: number, publicAttributes?: any | null | undefined, downloadUrl: string };

export type ShopVouchersQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type ShopVouchersQuery = { __typename: 'Query', shopVouchers: Array<{ __typename: 'ShopVoucherObject', id: number, code: string, currency: string, value: number, publicAttributes?: any | null | undefined, downloadUrl: string }> };

export type ShopVoucherQueryVariables = Types.Exact<{
  voucherId: Types.Scalars['Int']['input'];
}>;


export type ShopVoucherQuery = { __typename: 'Query', shopVoucher: { __typename: 'ShopVoucherObject', id: number, code: string, currency: string, value: number, publicAttributes?: any | null | undefined, downloadUrl: string } };

export const ShopVoucherFragmentDoc = gql`
    fragment ShopVoucher on ShopVoucherObject {
  id
  code
  currency
  value
  publicAttributes
  downloadUrl
}
    `;
export const ShopVouchersDocument = gql`
    query ShopVouchers($userId: Int!) {
  shopVouchers(userId: $userId) {
    ...ShopVoucher
  }
}
    ${ShopVoucherFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopVouchersGQL extends Apollo.Query<ShopVouchersQuery, ShopVouchersQueryVariables> {
    document = ShopVouchersDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopVoucherDocument = gql`
    query ShopVoucher($voucherId: Int!) {
  shopVoucher(voucherId: $voucherId) {
    ...ShopVoucher
  }
}
    ${ShopVoucherFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopVoucherGQL extends Apollo.Query<ShopVoucherQuery, ShopVoucherQueryVariables> {
    document = ShopVoucherDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }